import { doc, getDoc } from "firebase/firestore";
import React from "react";
import { db } from "../../../firebase";

const GetSingleIncome = async (IncomeId) => {
  try {
    const IncomeRef = doc(db, "Incomes", IncomeId);

    const IncomeSnapshot = await getDoc(IncomeRef);
    let SingleIncome;
    if (IncomeSnapshot.exists()) {
      SingleIncome = {
        id: IncomeSnapshot.id,
        ...IncomeSnapshot.data(),
      };
    }

    return SingleIncome;
  } catch (error) {
    console.log("Error Getting Income Data:", error);
    return;
  }
};

export default GetSingleIncome;
